<template>
	<div>
		<header class="sticky-top">
			<nav class="navbar navbar-expand-lg px-3">
				<a class="navbar-brand mx-auto" href="#">
					<img :src="logo" alt="bosCOD | Platform Kurir COD/Non-COD" width="auto" height="50">
				</a>
				<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
					<span class="navbar-toggler-icon"></span>
				</button>

				<div class="collapse navbar-collapse font-weight-bold" id="navbarSupportedContent">
					<ul class="navbar-nav mx-auto">
						<li class="nav-item dropdown">
							<a class="nav-link dropdown-toggle text-md text-secondary" data-toggle="dropdown" href="#">Layanan</a>
							<div class="dropdown-menu">
								<a class="dropdown-item text-md text-secondary" href="https://boscod.com" target="_blank">bosCOD</a>
								<a class="dropdown-item text-md text-secondary" href="https://bosagen.com" target="_blank">bosAgen</a>
								<a class="dropdown-item text-md text-secondary" href="https://boscs.id" target="_blank">bosCS</a>
								<a class="dropdown-item text-md text-secondary" href="https://bosonline.id" target="_blank">bosOnline</a>
								<a class="dropdown-item text-md text-secondary" href="https://pastiasli.id" target="_blank">PastiAsli</a>
							</div>
						</li>
						<li class="nav-item">
							<a class="nav-link text-md text-secondary" href="https://ww3.boscod.com/#keuntungan">Keuntungan</a>
						</li>
						<li class="nav-item">
							<a class="nav-link text-md text-secondary" href="https://ww3.boscod.com/#alur-pengiriman">Alur Pengiriman</a>
						</li>
						<li class="nav-item active">
							<a class="nav-link text-md text-secondary" :href="url + '/ongkir'">Cek Ongkir</a>
						</li>
						<li class="nav-item">
							<a class="nav-link text-md text-secondary" :href="url + '/lacak'">Lacak</a>
						</li>
					</ul>
					<div class="form-inline d-flex justify-content-around my-2 my-lg-0">
						<a class="btn btn-outline-primary rounded-pill my-2 my-sm-0 mx-2 text-primary" href="login">Masuk</a>
						<a class="btn btn-primary rounded-pill my-2 my-sm-0 mx-2 text-light" href="register">Daftar Sekarang</a>
					</div>
				</div>
			</nav>
		</header>
		<main role="main" class="bg-hero vh-100 py-4" style="min-height: fit-content;">
			<section class="container py-4">
				<h3 class="font-weight-bold text-center mb-3">Cek Tarif Ongkir Terbaik</h3>
				<form role="form" @submit="submitForm" class="card glass-effect rounded">
					<div class="card-body">
						<div class="row text-disabled">
							<div class="col-12 col-md">
								<div class="form-group">
									<label for="no_resi">Asal<span class="text-danger">*</span></label>
									<v-select label="name" name="origin" :filterable="false" :options="origins" v-model="form.origin" :reduce="(opt) => opt.id" @search="onSearch1" placeholder="Kecamatan, Kota/Kabupaten" required>
										<template slot="no-options"> Ketik asal pengiriman... </template>
										<template slot="option" slot-scope="option">
											<div class="d-center">
												{{ option.lokasi }}
											</div>
										</template>
										<template slot="selected-option" slot-scope="option">
											<div class="selected d-center">
												{{ option.lokasi }}
											</div>
										</template>
									</v-select>
								</div>
							</div>
							<div class="col-12 col-md">
								<div class="form-group">
									<label for="no_resi">Tujuan<span class="text-danger">*</span></label>
									<v-select label="name" name="destination" :filterable="false" :options="destinations" v-model="form.destination" :reduce="(opt) => opt.id" @search="onSearch2" placeholder="Kecamatan, Kota/Kabupaten" required>
										<template slot="no-options"> Ketik tujuan pengiriman... </template>
										<template slot="option" slot-scope="option">
											<div class="d-center">
												{{ option.lokasi }}
											</div>
										</template>
										<template slot="selected-option" slot-scope="option">
											<div class="selected d-center">
												{{ option.lokasi }}
											</div>
										</template>
									</v-select>
								</div>
							</div>
							<div class="col-12 col-md-auto">
								<div class="form-group">
									<label for="no_resi">Berat</label>
									<div class="input-group rounded">
										<input type="number" step="0.1" min="0.5" name="no_resi" id="no_resi" v-model="form.weight" placeholder="Contoh : 1 - 99" class="form-control rounded-left border-right-0" required />
										<div class="input-group-append">
											<div class="input-group-text form-control border-left-0 rounded-right">Kg</div>
										</div>
									</div>
								</div>
							</div>
							<div class="col-auto ml-auto">
								<div class="form-group">
									<label for="submit">&nbsp;</label>
									<button type="submit" :disabled="checking" name="submit" id="submit" class="btn btn-primary rounded-pill d-block">Cek Ongkir</button>
								</div>
							</div>
						</div>
					</div>
				</form>
			</section>
			<section class="container py-4" v-if="resultOngkir.length > 0">
				<div class="overlay w-100 text-center" v-if="checking"><h1 style="font-size:40px;">Sedang diproses <i class="fas fa-sync-alt fa-spin"></i></h1></div>
				<div class="card glass-effect rounded-pill">
					<div class="card-body">
						<div class="row d-flex justify-content-between align-items-center">
							<div class="col">
								<div class="form-control p-0 h-100 rounded-pill" :class="(service_category == 0 ? 'badge-cod' : 'border')" style="border-width: 2px;">
									<input type="radio" id="regular" name="service_category" v-model="service_category" value="0" hidden  @click="onToggleChange(0)"/>
									<label for="regular" class="form-check-label cursor-pointer text-center font-weight-bold w-100 p-2" :class="{ 'text-secondary' : service_category != 0 }">Reguler</label>
								</div>
							</div>
							<div class="col">
								<div class="form-control p-0 h-100 rounded-pill" :class="(service_category == 2 ? 'badge-cod' : 'border')" style="border-width: 2px;">
									<input type="radio" id="sameday" name="service_category" v-model="service_category" value="2" hidden  @click="onToggleChange(2)"/>
									<label for="sameday" class="form-check-label cursor-pointer text-center font-weight-bold w-100 p-2" :class="{ 'text-secondary' : service_category != 2 }">Sameday</label>
								</div>
							</div>
							<div class="col">
								<div class="form-control p-0 h-100 rounded-pill" :class="(service_category == 3 ? 'badge-cod' : 'border')" style="border-width: 2px;">
									<input type="radio" id="nextday" name="service_category" v-model="service_category" value="3" hidden  @click="onToggleChange(3)"/>
									<label for="nextday" class="form-check-label cursor-pointer text-center font-weight-bold w-100 p-2" :class="{'text-secondary' : service_category != 3}">Nextday</label>
								</div>
							</div>
							<div class="col">
								<div class="form-control p-0 h-100 rounded-pill" :class="(service_category == 1 ? 'badge-cod' : 'border')" style="border-width: 2px;">
									<input type="radio" id="cargo" name="service_category" v-model="service_category" value="1" hidden  @click="onToggleChange(1)"/>
									<label for="cargo" class="form-check-label cursor-pointer text-center font-weight-bold w-100 p-2" :class="{'text-secondary' : service_category != 1}">Cargo</label>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="card border rounded" v-for="item in listCourierSelect" :class="service_promo.includes(item.service) ? ' fade-in-left-3 bg-promo' : 'fade-in-top'">
					<div class="card-body">
						<div class="row">
							<div class="col-md col-sm-12">
								<img :src="getKurirLogo(item.kurir)" style="height:40px;" :class="{'bg-light rounded' : service_promo.includes(item.service)}" />
							</div>
							<div class="col-md col-sm-12" v-if="item.rating > 0">
								<div  class="description text-left mt-0">
									<span class="description-text" :class="{'text-secondary' : !service_promo.includes(item.service)}">Rating kurir</span>
									<div class="row" style="align-items: center;">
										<star-rating :inline="true" :star-size="15" :read-only="true" :show-rating="false" :rating="Number(item.rating)" style="margin-bottom: 6px;" :increment="0.01"></star-rating>
										<h6 class="description-header" :class="{'font-weight-bold' : service_promo.includes(item.service)}" style="margin-top: 5px; margin-left: 5px;">{{ item.rating }}</h6>
									</div>
								</div>
							</div>
							<div class="col-md col-sm-12">
								<div class="description text-left mt-0">
									<span class="description-text" :class="{'text-secondary' : !service_promo.includes(item.service)}">Service kurir</span>
									<h6 class="description-header" :class="{'font-weight-bold' : service_promo.includes(item.service)}" style="margin-top: 5px;">{{ item.serviceName }}</h6>
								</div>
							</div>
							<div class="col-md col-sm-12">
								<div class="description text-left mt-0">
									<span class="description-text" :class="{'text-secondary' : !service_promo.includes(item.service)}">Estimasi</span>
									<h6 v-if="item.etd_thru == false" class="description-header" :class="{'font-weight-bold' : service_promo.includes(item.service)}" style="margin-top: 5px;"> - </h6>
									<h6 v-else class="description-header" :class="{'font-weight-bold' : service_promo.includes(item.service)}" style="margin-top: 5px;">{{ item.etd_from }} - {{ item.etd_thru }} hari</h6>
								</div>
							</div>
							<div class="col-md col-sm-12">
								<div class="description text-left mt-0">
									<span class="description-text" :class="{'text-secondary' : !service_promo.includes(item.service)}">Tipe Kiriman</span>
									<div>
										<span v-if="item.cod == '1'" class="badge badge-cod" style="margin-right: 2px;">COD</span>
										<span class="badge badge-cod">NONCOD</span>
									</div>
								</div>
							</div>
							<div class="col-md col-sm-12">
								<div class="description text-left mt-0">
									<span class="description-text" :class="{'text-secondary' : !service_promo.includes(item.service)}">Tarif Ongkir</span>
									<h6 class="description-header"><s class="text-secondary" :class="{'text-stroke' : service_promo.includes(item.service)}">{{ formatRupiah(item.maxPrice) }}</s> <span class="text-success font-weight-bold" :class="{'text-stroke' : service_promo.includes(item.service)}">{{ formatRupiah(item.price_after_disc)}}</span>&nbsp;<i class="fas fa-info-circle" :title="'Diskon '+item.percent_cashback+'%'"></i></h6>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</main>
	</div>
</template>
<script src="https://unpkg.com/vue-star-rating@next/dist/VueStarRating.umd.min.js"></script>
<script>
import Vue from 'vue'
import { formatRupiah } from "@/libs/hxcore";
import $ from "jquery";
import Swal from "sweetalert2";
import vSelect from 'vue-select';
import "vue-select/dist/vue-select.css";
import StarRating from 'vue-star-rating';
export default {
	name: "Cek Ongkir",
	components: {
		vSelect,
        StarRating
	},
	data() {
		return {
			url: window.location.origin,
			logo: '',
            service_category: null,
			service_promo: ["UDREGFLAT","00"],
			service_recommendation:  ["UDREGFLAT","00","06"],
			origins: [],
			destinations: [],
			form: {
				origin: '',
				destination: '',
				weight: 1
			},
			resultOngkir: [],
            listCourier: [],
			listCourierSelect: [],
			checking: false,
		};
	},
	created: function(){
		if(Vue.config.appHost == 'xpress')
			this.logo = require(`../assets/img/logo-xpress.png`);
		else this.logo = require(`../assets/img/logo-min.svg`);
	},
	methods: {
		onSearch1(search, loading) {
			if (search.length > 3) {
				loading(true);
				//this.search(loading, search, this);
				var vm = this;
				fetch(window.$apiUrl + `/publik/city?q=${escape(search)}`).then((res) => {
					res.json().then((json) => (vm.origins = json.items));
					loading(false);
				});
			}
		},
		onSearch2(search, loading) {
			if (search.length > 3) {
				loading(true);
				//this.search(loading, search, this);
				var vm = this;
				fetch(window.$apiUrl + `/publik/city?q=${escape(search)}`).then((res) => {
					res.json().then((json) => (vm.destinations = json.items));
					loading(false);
				});
			}
		},
		submitForm: function(ev) {
			ev.preventDefault();
			if (!this.form.origin) {
				this.resultOngkir = [];
				return Swal.fire("Asal gudang belum dipilih!", ``, "error");
			}
			if (!this.form.destination) {
				this.resultOngkir = [];
				return Swal.fire("Tujuan pengiriman belum dipilih!", ``, "error");
			}
			this.loadCourier(this.form);
		},
        async loadCourier() {
			this.checking = true;
			try {
				await fetch(window.$apiUrl + "/publik/kurir").then(res => {
					res.json().then(json => {
						if (json.success == true) {
							this.listCourier = json.data;
							this.service_promo = json.service_promo;
							this.service_recommendation = json.service_recommendation;
							if (this.form.origin && this.form.destination && this.form.weight){
								this.loadOngkir(this.form);
							}
						} else {
							Swal.fire({
								title: "Oops...",
								icon: "error",
								text: json.message,
								showCloseButton: true
							});
						}

					});
				});
			} catch (error) {
				this.checking = false;
			}
		},
		loadOngkir(params) {
			let data;
			data = Object.keys(params)
			.map(
				(key) =>
				encodeURIComponent(key) + "=" + ((params[key] ===false || params[key] === undefined)?0 : encodeURIComponent(params[key]))
			)
			.join("&");
			fetch(window.$apiUrl + "/publik/ongkir?" + data).then((res) => {
				res.json().then(json => {
					const dataToProcess = Array.isArray(json) ? json : (json.data ? json.data : [json]);
					dataToProcess.forEach(async (val) => {
						await new Promise((resolve) => {
							this.resultOngkir = [...this.resultOngkir, val].sort((a, b) => {
							const aIdx = this.service_recommendation.indexOf(a.service || '');
							const bIdx = this.service_recommendation.indexOf(b.service || '');
							if (aIdx === -1 && bIdx === -1) return 0;
							if (aIdx === -1) return 1;
							if (bIdx === -1) return -1;
							return aIdx - bIdx;
							});
							resolve();
						});
					});
					this.checking = false;
					if (Object.keys(this.resultOngkir).length == 1 && Object.keys(this.listCourier).length == 1) {
						this.selectService(0);
					} else {
						this.showServiceList = true;
					}
					this.onToggleChange(99);
				}).
				finish(
					this.ongkirInProgres.push(...params.courier)
				);
			});
		},
		getKurirLogo(kurir) {
			const fileName = kurir.toLowerCase();
			return require(`../assets/img/${fileName}.png`); // the module request
		},
		formatRupiah(value) {
			return formatRupiah(value);
		},
		onToggleChange: function(filter)
		{
            var listCourierSelect = [];
			if (filter == 99 || this.service_category == filter) {
				this.listCourierSelect = this.resultOngkir;
				this.service_category = 99;
			} else {
				for (let i = 0; i < this.resultOngkir.length; i++) {
					if (this.resultOngkir[i].category == filter){
						listCourierSelect.push(this.resultOngkir[i]);
					}
				}
				this.listCourierSelect = listCourierSelect;
			}
		},
	},
	mounted() {
		if (this.$route.params.id) {
			this.orderCode = this.$route.params.id;
			this.loadInfo(this.orderCode);
			this.loadHistory(this.orderCode);
		}
	}
};
$(function () {
});
</script>
<style scoped src="../assets/login.css"></style>
<style scoped>
header {
	background-color: #fff4e6;
}

.glass-effect {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.bg-hero {
    background-image: url("~@/assets/img/hero-background.svg");
    background-size: cover;
	background-position: center top;
    background-repeat: repeat-y;
	background-attachment: fixed;
}

.text-stroke {
  text-shadow:
    0.5px 0 0 white,
   -0.5px 0 0 white,
    0 0.5px 0 white,
    0 -0.5px 0 white;
}

@keyframes shimmer-infinite {
    0% {
        background-position: 50% 0;
    }
    50% {
        background-position: 0% 0;
    }
    100% {
        background-position: 50% 0;
    }
}

@keyframes ease-in-right {
    0% {
        opacity: 0;
        transform: translateX(-20%);
    }
    100% {
        opacity: 1;
        transform: translateX(0);
    }
}

@keyframes ease-in-top {
    0% {
        opacity: 0;
        transform: translateY(-20%);
    }
    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

.fade-in-left-3 {
    background: linear-gradient(90deg, #FF7203, #FF9300);
    /* background-size: 200% 100%; */
    animation: 
        shimmer-infinite 30s infinite linear,
        ease-in-right 0.3s backwards;
    transition: transform 0.1s;
}

.bg-promo {
	background-color: #FF7203;
	/* background-image: url("~@/assets/img/bg-withdraw.svg"); */
	background-image: url("~@/assets/img/BackgroundCourier.svg");
	background-repeat: no-repeat;
	background-size: 100%;
	border-radius: 6px;
	border: 1px solid #944100;
	color:#ffffff;
	background-size: cover;
}

.fade-in-top {
    animation: ease-in-top 0.1s forwards;
    transition: transform 0.1s;
}
</style>
